var exports = {
  "Do": "xaee3c4fa--cfa885--sections-wrapper",
  "$r": "xaee3c4fa--cfa885--_is-search-shown",
  "iE": "xaee3c4fa--cfa885--wrapper",
  "Cp": "xaee3c4fa--cfa885--main-area",
  "Ii": "xaee3c4fa--cfa885--pre-footer",
  "yh": "xaee3c4fa--cfa885--pre-footer-main-area",
  "Vb": "xaee3c4fa--cfa885--pre-footer-sidebar-area",
  "QC": "xaee3c4fa--cfa885--adfox-banner-footer",
  "pz": "xaee3c4fa--cfa885--sidebar",
};

module.exports = exports;
